import { computed, ref } from 'vue';
import { useStore } from '@/store/index'
import FuncoesHelper from '@/helpers/FuncoesHelper';

class ComponentePreviewChecklistService {
    setup({ modulo }) {
        const store = useStore()
        const identificador = ref(FuncoesHelper.obterParametrosRota('identificador'))
        const modulos = computed(() => {
            return store.state.modulos.filter(module => parseInt(module.idChecklistModulo) !== parseInt(modulo))
        })
        return { modulos, identificador }
    }
}

export default new ComponentePreviewChecklistService()